import React, {useEffect, useState} from 'react'
import Navbar from '../Navbar/Navbar.component';
import { handleLogin } from '../Navbar/Navbar.component';
import ProductsTable from '../ProductDisplay/ProductDisplay.component';
import './loginsuccess.css'


// get name from JWT
export function decodeJWT(token) {
  const parts = token.split('.');
  if (parts.length !== 3) {
      throw new Error('The token is invalid');
  }
  const payload = parts[1];
  const decodedPayload = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
  const payloadObj = JSON.parse(decodedPayload);
  return payloadObj;
}



function Loginsuccess() {
    const [username, setUserName] = useState("")
    const [displayedName, setDisplayedName] = useState("");
    const [idTokenState, setIdTokenState] = useState()
    const [accessTokenState, setAccessTokenState] = useState()
    const [activeTier, setActiveTier] = useState()

    const products = [
      {
        name: 'Free',
        Price: '$0',
        'Calls limit per day': '15',
        'Highlighted text characters limit': '2000',
        'Input query characters limit': '500',
        'Models': 'GPT-3.5',
        'Output characters limit': '1000',
      },
      {
        name: 'Standard',
        Price: '$8',
        'Calls limit per day': '100',
        'Highlighted text characters limit': '2500',
        'Input query characters limit': '700',
        'Models': 'GPT-3.5 & GPT-4',
        'Output characters limit': '1200',
      },
      {
        name: 'Pro',
        Price: '$12',
        'Calls limit per day': '150',
        'Highlighted text characters limit': '5000',
        'Input query characters limit': '1500',
        'Models': 'GPT-3.5 & GPT-4',
        'Output characters limit': '2000',
      }
    ]

    // Function to gradually display the username
    function writeNameGradually(name) {
      if (!name) return
      let index = 0;
      function addCharacter() {
          if (index <= name.length) {
              setDisplayedName((name.slice(0,index)));
              index++;
              setTimeout(addCharacter, 150); // Adjust the delay as needed
          }
      }
      addCharacter();
  }


    function handleCustomerPortal(){
      let jsonData = JSON.stringify({
        id_token: idTokenState
      })
  
      fetch('https://p9arfzpha0.execute-api.ap-south-1.amazonaws.com/development/customer-portal', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: jsonData
      })
      .then(response => response.json())
      .then(data => {
        window.location.href = data})
      .catch(error => {
        console.error('Error:', error)});
    }

    function sendDataToExtension(data){
      window.postMessage(data, "*");
    }

    async function getCustomerProduct(idToken){
      let response = await fetch('https://p9arfzpha0.execute-api.ap-south-1.amazonaws.com/development/get-user-products', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        }
      })
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const responseData = await response.json();
      setActiveTier(responseData)
    }

    useEffect(() => {
        // Function to extract query parameters from the URL
        const getQueryParams = (params, url) => {
          let href = url;
          let reg = new RegExp('[#&]' + params + '=([^&#]*)', 'i');
          let queryString = reg.exec(href);
          return queryString ? queryString[1] : null;
        };
     
        // Assume the tokens are in the URL's query string
        const accessToken = getQueryParams('access_token', window.location.href);
        const idToken = getQueryParams('id_token', window.location.href);

        setAccessTokenState(accessToken)
        setIdTokenState(idToken)

        // Check if the tokens are avaiable then send them to the extension
        if (accessToken && idToken) {
            let decoded_idToken = decodeJWT(idToken)
    
            if (Date.now()/1000>decoded_idToken.exp){
              handleLogin()
              return
            }
            
            setUserName(decoded_idToken.name)

            getCustomerProduct(idToken)
        } else {
          handleLogin()
        }
      }, []);

      useEffect(()=>{
        if (username) {
          writeNameGradually(username + "!");
      }
      }, [username])

      useEffect(()=>{
        if (accessTokenState && idTokenState && activeTier){
          let data = { type: "mrkrtk", accessToken: accessTokenState, idToken: idTokenState, activeTier: activeTier };
          sendDataToExtension(data)
        }
        
      }, [activeTier])
    
      return (
        <div>
          <Navbar login={true}/>
          <div id="userNameDisplay" class="hidden">
            <span>Hello</span>
            <span id="UserNameField">{displayedName}</span>
          </div>
          <div className='newsMessage'>
            <h4>Your current Tier: {activeTier}</h4>
          </div>
          <div>
            <ProductsTable products={products} accessTokenState={accessTokenState} idTokenState={idTokenState} activeTier={activeTier} handleCustomerPortal={handleCustomerPortal}/>
          </div>
          
        </div>
      );
}

export default Loginsuccess